import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { getPrettyCarrierName } from "@redotech/redo-web/carrier-service-labels";
import PackageIcon from "@redotech/redo-web/icon-old/package.svg";

const entry = fgFilterEntries.selectedCarrier;

export const SelectedCarrierFilter: AdvancedTableFilter = {
  type: entry.type,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "carrier",
  Icon: PackageIcon,
  values: [...entry.staticValues].sort((a, b) => a.localeCompare(b)),
  display: (item: Carriers) => getPrettyCarrierName(item),
  displayName: entry.displayName,
};
